import React from "react";
import MainLayout from "../../layouts/MainLayout";
import SyncNextStyleHead from "../../components/seo/SyncNextStyleHead";
// import { getQuoteCorporate } from "../../util/getQuoteCorporate";
import CorporateLeadForm from "../../modules/landingpages/CorporateLeadForm";

function GetQuotePageCorporateDelhiNcr() {
  return (
    <MainLayout>
      {/* <SyncNextStyleHead>{getQuoteCorporate()}</SyncNextStyleHead> */}
      <CorporateLeadForm />
    </MainLayout>
  );
}

export default GetQuotePageCorporateDelhiNcr;
